export default __webpack_public_path__ + "static/media/icon.35df9317.png";